import vod from "../pages/vod/routes";
import search from "../pages/search/routes";
import setup from "../pages/setup/routes";


export default [...vod, ...search, ...setup];